export default __webpack_public_path__ + "static/media/emptydata.1d25e5c9.svg";